import { Autocomplete, Box, Button, Divider, Grid, IconButton, Modal, Stack, TextField, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useForm } from '../../../hooks';
import { useDispatch, useSelector } from 'react-redux';
import { NumberInput } from '../NumberInput';
import { unSelectInvestment } from '../../../store/investment/investmentSlice';
import { Field } from '../miProfile/Field';
import { editInvestment } from '../../helpers/investments';
import { style } from '../../../helpers/editStyle';
import { DateInput } from '../DateInput';

export const EditInvestment = ({ setHidden, setReloadData, vehiclesList }) => {

    const { t } = useTranslation('global');
    const { dataToAction } = useSelector(state => state.investment)

    const dispatch = useDispatch();
    const [formValues, handleInputChange, reset] = useForm(dataToAction);

    const { whoInvests, amount, participationValuation, vehicle, investmentDate } = formValues;


    const handleCancel = () => {
        reset()
        dispatch(unSelectInvestment())
        setHidden(false)
    }
    const onSubmit = async(e) => {
        e.preventDefault();
        await editInvestment(formValues, t('investments.succesEditMsg'), t('investments.errorMsg'))
        setReloadData(prevState => !prevState)
        setHidden(false)
    }

    return (
        <Modal
            open={true}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ zIndex: 9999 }}
        >
            <Box sx={style}>
                <Stack direction='row' justifyContent='space-between' alignItems='baseline' sx={{ height: '50px' }}>
                    <Typography color='primary' marginBottom='10px' variant='h5' fontWeight={700}>{t('investments.editInvestment')}</Typography>
                    <IconButton color='primary' onClick={handleCancel}>
                        <CloseRoundedIcon />
                    </IconButton>
                </Stack>
                <form onSubmit={onSubmit} style={{ padding: '10px 5px', display: 'flex', flexDirection: 'column', justifyContent: 'space-around' }}>
                    <Stack sx={{ height: 'calc(70vh - 200px)', overflowY: 'auto', paddingBottom: '10px', paddingRight: '20px' }}>

                        <Stack direction='column' width='100%' gap={0}>
                            <Field name={whoInvests} title='whoInvests' handleInputChange={handleInputChange} translation='investments' isDisabled={true} />
                        </Stack>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='investments' name={amount} title='amount' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <NumberInput translation='investments' name={participationValuation} title='participationValuation' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} padding='0 5px'>
                                <DateInput name={investmentDate} title='investmentDate' handleInputChange={handleInputChange} required={true} />
                            </Grid>
                        </Grid>

                        <Stack direction='column' width='100%' gap={0}>
                            <Typography variant='overline' color='secondary'>{t('opportunities.vehicle')}</Typography>
                            <Autocomplete
                                disablePortal
                                options={vehiclesList}
                                size='small'
                                renderInput={(params) => <TextField  {...params} variant='outlined' name='vehicle' />}
                                value={vehicle}
                                onSelect={handleInputChange}
                                fullWidth
                                required
                            />
                        </Stack>

                    </Stack>

                    <Stack sx={{ heigth: '80px' }}>
                        <Divider sx={{ margin: '30px 0px 15px 0px' }} />

                        <Grid container direction='row' width='100%' >
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth onClick={handleCancel} variant="text">{t("createPassword.cancelButton")}</Button>
                            </Grid>
                            <Grid item xs={12} md={6} padding='0 5px'>
                                <Button fullWidth type='submit' variant="contained">{t("createPassword.principalButton")}</Button>
                            </Grid>
                        </Grid>
                    </Stack>
                </form>

            </Box>
        </Modal>
    )
}
